module.exports = __webpack_public_path__ + "static/media/data-overflow.ab86c4ee.png";